const SALESFORCE_BASE_URL = '/v1/integrations/salesforce';

const SALESFORCE_API_ENDPOINTS = {
  SETUP: `${SALESFORCE_BASE_URL}/setup`,
  TOGGLE_AUTH: `${SALESFORCE_BASE_URL}/toggle_auth`,
  USER_DETAILS: `${SALESFORCE_BASE_URL}/{sm_id}/current_user`,
};

const SALESFORCE_ENABLED = 1;

const SALESFORCE_LOGOUT_MODAL_TEXT = {
  TITLE: 'Are you sure you want to disable Salesforce Integration?',
  MESSAGE: 'Please note that all Automation rules containing Salesforce conditions or actions will be disabled',
};

const SALESFORCE_AUTH_REQUIRED_TEXT = '*Salesforce authentication required  ';

const SALESFORCE_AUTH_MODAL_TEXT = {
  TITLE: 'Requires Salesforce automation to be enabled',
  MESSAGE: 'You have to authenticate and enable Salesforce automations before you can start using Salesforce conditions on automation rules.',
  GOTO_SETTINGS_BUTTON: 'Go to Salesforce integration settings',
  AUTH_AND_ENABLE_BUTTON: 'Authenticate and enable',
};

export {
  SALESFORCE_ENABLED,
  SALESFORCE_API_ENDPOINTS,
  SALESFORCE_LOGOUT_MODAL_TEXT,
  SALESFORCE_AUTH_REQUIRED_TEXT,
  SALESFORCE_AUTH_MODAL_TEXT,
};
